"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const TGLabelWrapper = props => {
    const { label, info, oneLine } = props;
    const labelStyles = useLabelStyles();
    const ElementType = oneLine ? 'span' : 'div';
    return (react_1.default.createElement(ElementType, { style: oneLine ? undefined : labelStyles.labelWrapper },
        react_1.default.createElement(ElementType, { className: 'labelWrapper-label', style: Object.assign(Object.assign({}, (!info && labelStyles.info)), labelStyles.label) }, label ? label + (oneLine ? ': ' : '') : '')));
};
const useLabelStyles = () => ({
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    info: {
        paddingRight: 0,
    },
    label: {
        fontWeight: '400',
        fontSize: 14,
        marginRight: 2,
        lineHeight: '130%',
        fontFamily: 'Roboto,Roboto-Regular',
    },
});
exports.default = TGLabelWrapper;
//# sourceMappingURL=TGPageLabelWrapper.js.map